import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ReferentielService {

  private data: Promise<any>;

  private readonly baseApiUrl: string = environment.api.baseUrl;

  constructor(private http: HttpClient) {

  }

  private createPromise(): Promise<any> {
    return this.http.get(this.baseApiUrl + 'referentiels').toPromise().then(
      data => {
        return data;
      },
      data => {
        throw new Error('An unexpected error occurred while data loading : ' + data);
      });
  }

  public all(): Promise<any> {
    if (!this.data) {
      this.data = this.createPromise();
    }
    return this.data;
  }

  public getReferentiel(referentiel: string): Promise<string> {
    return this.all().then(data => {
      if(!referentiel) {
        return null;
      }
      if(!data.hasOwnProperty(referentiel)) {
        throw new Error('Ce référentiel "' + referentiel + '" n\'existe pas');
      }
      return data[referentiel];
    });
  }

  public get(referentiel: string, key: string): Promise<string> {
    return this.getReferentiel(referentiel).then(data => {
      if(!key) {
        return null;
      }
      if(!data.hasOwnProperty(key)) {
        throw new Error('Cette clé \'' + key + '\' n\'existe pas dans le référentiel \'' + referentiel + '\'');
      }
      return data[key];
    });
  }

}
